namespace GeniuzPOS.QRreport {
    export interface QRywcSpec1320Form {
        ReportId: Serenity.LookupEditor;
        ReportName: Serenity.StringEditor;
        UrlReport: Serenity.StringEditor;
        DataStructureName: Serenity.StringEditor;
        LineNo: Serenity.IntegerEditor;
        DateBegin: Serenity.DateEditor;
        DateEnd: Serenity.DateEditor;
        ShopId: Serenity.LookupEditor;
        PromoCampaign: Serenity.LookupEditor;
        PluCode: Serenity.LookupEditor;
        CatCode: Serenity.LookupEditor;
        SubCat1Code: Serenity.LookupEditor;
        SubCat2Code: Serenity.LookupEditor;
        BrandCode: Serenity.LookupEditor;
        StyleId: Serenity.LookupEditor;
        ColorId: Serenity.LookupEditor;
        SizeId: Serenity.LookupEditor;
        TasteId: Serenity.LookupEditor;
        MatTypeId: Serenity.LookupEditor;
        SupplId: Serenity.LookupEditor;
        ConsignFg: Serenity.EnumEditor;
    }

    export class QRywcSpec1320Form extends Serenity.PrefixedContext {
        static formKey = 'QRreport.QRywcSpec1320';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!QRywcSpec1320Form.init)  {
                QRywcSpec1320Form.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.StringEditor;
                var w2 = s.IntegerEditor;
                var w3 = s.DateEditor;
                var w4 = s.EnumEditor;

                Q.initFormType(QRywcSpec1320Form, [
                    'ReportId', w0,
                    'ReportName', w1,
                    'UrlReport', w1,
                    'DataStructureName', w1,
                    'LineNo', w2,
                    'DateBegin', w3,
                    'DateEnd', w3,
                    'ShopId', w0,
                    'PromoCampaign', w0,
                    'PluCode', w0,
                    'CatCode', w0,
                    'SubCat1Code', w0,
                    'SubCat2Code', w0,
                    'BrandCode', w0,
                    'StyleId', w0,
                    'ColorId', w0,
                    'SizeId', w0,
                    'TasteId', w0,
                    'MatTypeId', w0,
                    'SupplId', w0,
                    'ConsignFg', w4
                ]);
            }
        }
    }
}
